import React from 'react';

import "./readingLevelOverview.less";

const ReadingLevelOverview = ({ children }) => (
	<div className="reading-level-overview">
		{children}
	</div>
);

export default ReadingLevelOverview;



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/ReadingLevelOverview.jsx